import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { XMEI_SECONDARY_COLOR } from 'src/consts/common';

const useStyles = () => ({
  root: {
    marginTop: '0.6em',
    padding: '15px 14px',
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: XMEI_SECONDARY_COLOR,
    },
  },
});

export const InputButton = withStyles(useStyles)(Button);
